import type { ButtonProps } from '~/components/ui/button';

import { cva } from 'class-variance-authority';

export type ConvinientVariant = 'primary' | 'dark';

const convinientTitleVariants = cva(
	'flex w-full items-center font-matter-sq text-lg leading-[150%] tracking-[-0.36px]',
	{
		variants: {
			variant: {
				primary: 'text-primary',
				dark: 'text-white'
			}
		},
		defaultVariants: { variant: 'primary' }
	}
);

const convinientLabelVariants = cva('text-base font-normal leading-normal', {
	variants: {
		variant: {
			primary: 'text-primary',
			dark: 'text-white-dark-4'
		}
	},
	defaultVariants: { variant: 'primary' }
});

const convinientInactiveButtonVariants = cva('', {
	variants: {
		variant: {
			primary: 'tertiary',
			dark: 'secondary-dark'
		}
	},
	defaultVariants: { variant: 'primary' }
});

export function getConvinientStyles(variant: ConvinientVariant) {
	return {
		title: convinientTitleVariants({ variant }),
		label: convinientLabelVariants({ variant }),
		inactiveButton: convinientInactiveButtonVariants({
			variant
		}) as ButtonProps['variant']
	};
}
